
(function() {
  function initRoutineATC() {
    var footers = document.querySelectorAll('.pet-routine-section .card-footer');
    if (!footers.length) return;

    footers.forEach(function(footer) {
      if (footer.dataset.rtcBound) return;
      footer.dataset.rtcBound = '1';
      footer.style.cursor = 'pointer';

      footer.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var btn = this.querySelector('[data-variant-id]') || this.querySelector('.add-button');
        if (!btn || btn.disabled) return;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) {
          var inp = this.querySelector('input[name="id"]');
          if (inp) variantId = inp.value;
        }
        if (!variantId) return;

        var card = this.closest('.product-card');
        var qtyInput = card ? card.querySelector('.routine-qty-input') : null;
        var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
        var origHTML = btn.innerHTML;

        btn.disabled = true;
        btn.innerHTML = 'ADDING...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: qty })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          btn.innerHTML = 'ADDED ✓';
          footer.style.background = '#28a745';
          fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
            document.querySelectorAll('.cart_count,.cart-count,[data-cart-count],.js-cart-count').forEach(function(el){el.textContent=cart.item_count});
          });
          setTimeout(function() { btn.innerHTML = origHTML; footer.style.background = ''; btn.disabled = false; }, 1800);
        })
        .catch(function() {
          btn.innerHTML = 'ERROR'; setTimeout(function() { btn.innerHTML = origHTML; btn.disabled = false; }, 2000);
        });
      });
    });

    document.querySelectorAll('.pet-routine-section .routine-qty-minus').forEach(function(b) {
      if (b.dataset.rtcBound) return; b.dataset.rtcBound = '1';
      b.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); var i = this.parentElement.querySelector('.routine-qty-input'); var v = parseInt(i.value)||1; if(v>1) i.value=v-1; });
    });
    document.querySelectorAll('.pet-routine-section .routine-qty-plus').forEach(function(b) {
      if (b.dataset.rtcBound) return; b.dataset.rtcBound = '1';
      b.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); var i = this.parentElement.querySelector('.routine-qty-input'); var v = parseInt(i.value)||1; if(v<10) i.value=v+1; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRoutineATC);
  } else {
    initRoutineATC();
  }
  setTimeout(initRoutineATC, 2000);
})();
